import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { CheckCircle2, Download, Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../ui/dialog';
import { haccpApi, erroreHaccp, dataIt } from '../haccpApi';
import { firmatari, firmatoDoc } from './firme/useFirme';

const Firmato = ({ documento }) => {
  if (!firmatoDoc(documento)) return null;
  const chi = firmatari(documento);
  return (
    <p className="flex items-start gap-2 rounded-xl bg-emerald-50 border border-emerald-200 px-3 py-2 text-xs text-emerald-900" data-testid="documento-viewer-firmato">
      <CheckCircle2 className="h-4 w-4 shrink-0 text-emerald-600" />
      <span><b>Documento firmato</b>{chi.length ? `: ${chi.map((a) => `${a.firmatario} il ${dataIt(a.il)}`).join(', ')}` : ''}</span>
    </p>
  );
};

// Il file si scarica con l'accesso del responsabile e si mostra qui (foto o PDF); ?v= cambia dopo ogni firma
export const VediDocumento = ({ documento, titolo, onClose }) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!documento) return undefined;
    let indirizzo = null;
    haccpApi.get(`/documenti/${documento.id}/file?v=${encodeURIComponent(documento.file?.uploaded_at || '')}`, { responseType: 'blob' })
      .then((blob) => { indirizzo = URL.createObjectURL(blob); setUrl(indirizzo); })
      .catch((e) => { toast.error(erroreHaccp(e, 'File non disponibile')); onClose(); });
    return () => { if (indirizzo) URL.revokeObjectURL(indirizzo); setUrl(null); };
  }, [documento, onClose]);
  const pdf = documento?.file?.content_type === 'application/pdf';
  return (
    <Dialog open={!!documento} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl w-[96vw] rounded-2xl" data-testid="documento-viewer">
        <DialogHeader>
          <DialogTitle className="pr-6">{titolo}</DialogTitle>
          <DialogDescription>{documento?.file?.filename}</DialogDescription>
        </DialogHeader>
        <Firmato documento={documento} />
        {!url ? <div className="h-64 flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-gray-400" /></div> : (
          <>
            {pdf ? <iframe src={url} title={titolo} className="w-full h-[65vh] rounded-lg bg-white" data-testid="documento-viewer-pdf" />
              : <img src={url} alt={titolo} className="max-h-[65vh] w-full object-contain rounded-lg" data-testid="documento-viewer-img" />}
            {pdf && <p className="text-[11px] text-gray-500 text-center">Sul telefono non vedi l'anteprima? Premi Scarica per aprire il PDF.</p>}
            <a href={url} download={documento?.file?.filename || 'documento'} data-testid="documento-viewer-scarica"
              className="h-11 rounded-full bg-gray-900 text-white text-sm font-semibold flex items-center justify-center gap-2">
              <Download className="h-4 w-4" />Scarica
            </a>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
